import Keystation from "@cosmostation/keystation-es6";
import { rawTxtoJson } from "../lib/tendermint";

const Account = ({ keystation, prefix }, args = {}) => {
  keystation.path = args.hdPath.replace(/'|m\//g, "");
  const getAddress = async () => {
    const { address } = getKeystationAccount();
    if (address) return address;
    return new Promise((resolve, reject) => {
      const popup = keystation.openWindow("signin", prefix);
      const getAddrInt = setInterval(() => {
        const { address } = getKeystationAccount();
        if (address) {
          clearInterval(getAddrInt);
          resolve({ address });
        } else if (popup.closed) {
          clearInterval(getAddrInt);
          reject(new Error("Keystation window closed."));
        }
      }, 100);
    });
  };

  const getPubKey = async () => {};

  const signTransaction = async (rawTx) => {
    return new Promise(async (resolve, reject) => {
      const { account } = getKeystationAccount();
      const popup = keystation.openWindow(
        "transaction",
        rawTxtoJson(rawTx),
        account
      );
      const signTxItv = setInterval(() => {
        if (window.keystationTx) {
          const { success, error, txhash } = window.keystationTx;
          delete window.keystationTx;
          clearInterval(signTxItv);
          if (!success)
            return reject(new Error(error || "Something went wrong!"));
          resolve({ txHash: txhash });
        } else if (popup.closed) {
          clearInterval(signTxItv);
          reject(new Error("Keystation window closed."));
        }
      }, 100);
    });
  };

  const sign = async (message) => {};

  const verifySignature = async (message, signature) => {};

  const handlePostMessage = (e) => {
    if (e.origin != "https://keystation.cosmostation.io") return;
    if (e.data.account) {
      storeKeystationAccount(e.data.account, e.data.address, keystation.path);
    }
    if (e.data === "deny") {
      window.keystationTx = {
        success: false,
        error: "Transaction denied by user.",
      };
    }
    if (e.data.txhash || e.data.tx_response?.txhash) {
      window.keystationTx = {
        success: true,
        txhash: e.data.txhash || e.data.tx_response.txhash,
      };
    }
  };

  window.removeEventListener("message", handlePostMessage);
  window.addEventListener("message", handlePostMessage);

  return {
    getAddress,
    getPubKey,
    sign,
    signTransaction,
    verifySignature,
  };
};

const Backend = ({ keystation, prefix }) => {
  const genAccount = async (args) =>
    Account({ keystation, prefix: prefix }, args);

  const getAccount = async (args) => genAccount(args);

  const cleanUp = async () => {
    clearKeystationAccount();
  };

  return {
    getAccount,
    cleanUp,
  };
};

Backend.create = async ({ keystationOptions = {} } = {}) => {
  if (keystationOptions.shouldCleanUp) {
    clearKeystationAccount();
  }
  const keystation = new Keystation();
  keystation.client = keystationOptions.clientWebUrl;
  keystation.lcd = keystationOptions.lcd;
  return Backend({ keystation, prefix: keystationOptions.prefix });
};

const storeKeystationAccount = (account, address, path) => {
  window.sessionStorage.setItem("keystationAccount", account);
  window.sessionStorage.setItem("keystationAddress", address);
  window.sessionStorage.setItem("keystationPath", path);
};

const clearKeystationAccount = () => {
  window.sessionStorage.removeItem("keystationAccount");
  window.sessionStorage.removeItem("keystationAddress");
  window.sessionStorage.removeItem("keystationPath");
};

const getKeystationAccount = () => {
  return {
    account: window.sessionStorage.getItem("keystationAccount"),
    address: window.sessionStorage.getItem("keystationAddress"),
    path: window.sessionStorage.getItem("keystationPath"),
  };
};

export default Backend;
